import React, { useEffect, useState } from 'react'
import { reactular } from '@vendhq/reactular'
import { Scrollable } from '@lightspeed/design-system-react'
import { vn } from 'vend-number'
import classNames from 'classnames'
import { BackToSaleHeader } from '../../payments/back-to-sale-header/BackToSaleHeader'
import { SaleSummaryLineItems } from '../sale-line-item/SaleSummaryLineItems'
import { useAppSelector } from '../../../state/hooks'
import {
  selectSaleStatus,
  selectSaleSummaryFields,
  selectSaleNote,
} from '../../../state/slices/currentSale/currentSaleSlice'
import { isQuote } from '../../../functions/sale'
import { useSaleManager } from '../../../ng-compat/hooks'
import { useFulfillmentTakeNowSaleData } from '../useFulfillmentTakeNowSaleData'
import { getScrollbarWidth } from '../../../util/scrollbar'
import { SubtotalSection } from './SubtotalSection'
import { CashDiscountSection } from './CashDiscountSection'
import { SaleTotalSection } from './SaleTotalSection'
import { AccountBalancePaymentSection } from './AccountBalancePaymentSection'

import { PaymentSection } from './PaymentSection'
import { ChangeAmountSection } from './ChangeAmountSection'
import { SaleNoteSection } from './SaleNoteSection'
import { TotalSavingsSection } from './TotalSavingsSection'
import { ToPaySection } from './ToPaySection'
import { TakeNowAndFulfillmentRemainingBalanceSection } from './TakeNowAndFulfillmentBalanceBreakdown'

export const SummaryPanel = () => {
  const [scrollbarWidth, setScrollbarWidth] = useState(0)
  const saleStatus = useAppSelector(selectSaleStatus)
  const totals = useAppSelector(selectSaleSummaryFields)
  const saleNote = useAppSelector(selectSaleNote)
  const saleManager = useSaleManager()
  const hasCashDiscountApplied = vn(totals.totals.cashDiscount).lessThan(0)
  const { shouldShowGroupingOfSaleLines } = useFulfillmentTakeNowSaleData()

  useEffect(() => {
    setScrollbarWidth(getScrollbarWidth())
  }, [])

  return (
    <>
      <BackToSaleHeader isQuote={isQuote(saleStatus)} />
      <hr className="vd-hr vd-hr--full vd-hide-desktop" />
      <div
        className="sale-summary"
        style={
          shouldShowGroupingOfSaleLines && scrollbarWidth > 0
            ? ({
                '--scrollbar-width': `${scrollbarWidth}px`,
              } as React.CSSProperties)
            : undefined
        }
      >
        <Scrollable
          className={classNames('sale-summary-content', {
            'stable-scrollbar': shouldShowGroupingOfSaleLines,
          })}
        >
          <section className="sale-summary-section sale-summary-section--sale-items sale-summary-section-divider-btm vd-pb4 vd-pt0">
            <SaleSummaryLineItems />
          </section>
          <section className="sale-summary-section sale-summary-section--indent">
            <SubtotalSection />
          </section>
          {saleManager.hasCashDiscountingServiceFee() &&
            hasCashDiscountApplied && <CashDiscountSection />}
          <SaleTotalSection />
          <AccountBalancePaymentSection />
          <PaymentSection />
          <ChangeAmountSection />
          {!shouldShowGroupingOfSaleLines ? <ToPaySection /> : null}
          {saleNote && <SaleNoteSection />}
          {vn(saleManager.getTotalSavings()).greaterThan(0) && (
            <TotalSavingsSection />
          )}
        </Scrollable>
        <TakeNowAndFulfillmentRemainingBalanceSection />
      </div>
    </>
  )
}

export const ReactSummaryPanel = reactular(SummaryPanel, [], 'reactWrapper')
